<template>
  <modal @close="$emit('close')" back="back">
    <template v-slot:header>Linked Project(s)</template>

    <div @keyup.esc="$emit('close')" v-focus tabindex="0" class="outline-none">
      <div class="center">
        <div :class="{ busy }" data-placeholder="Type to search for a project" class="border-bottom p2 placed relative">
          <input v-model="form.search" @focus="focussed = true" @blur="focussed = false" type="search" class="input border-none center">
        </div>
        <ul v-if="filtered" class="list-reset mb4 pb2">
          <li v-for="tag in filtered" :key="tag.item.id" class="py1 h6 mb0">
            <a @click="addNew(tag.item)" :class="{ strong: isSelected(tag.item) }" class="inline-block pointer p1"><highlight-text :item="tag"/></a>
          </li>
        </ul>
        <ul v-else class="list-reset mb4 pb2">
          <li v-for="proj in results" :key="proj.id" class="py1 h6 mb0">
            <a @click="addNew(proj)" :class="{ strong: isSelected(proj) }" class="inline-block pointer p1 px3">{{ proj.title }}</a>
          </li>
          <li v-if="loading" class="py1 h6 mb0">
            <span class="inline-block p1 gray">Loading...</span>
          </li>
        </ul>
      </div>
      <div @click="$emit('close')" class="absolute bottom-0 left-0 right-0 px2 pb2 bg-white h6 form-actions">
        <button type="button" class="btn btn-rounded white bg-black col-12">SAVE</button>
      </div>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios'
  import HighlightText from '@/components/HighlightText'
  import Fuse from 'fuse.js'

  export default {
    name: 'LinkedProjects',
    props: {
      list: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        loading: false,
        focussed: false,
        form: { search: null },
        results: null,
        fuse: null
      }
    },
    computed: {
      filtered () {
        if (!this.form.search || !this.results) return
        return this.fuse.search(this.form.search)
      },
      busy () {
        return this.form.search || this.focussed
      }
    },
    methods: {
      getProjects () {
        this.loading = true
        axios.get(process.env.VUE_APP_API_AC_ROOT + 'project-list').then(({ data }) => {
          this.results = data
          const options = {
            shouldSort: true,
            includeMatches: true,
            threshold: 0.1,
            location: 0,
            distance: 400,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            keys: ['title']
          }
          this.fuse = new Fuse(this.results, options)
        }).finally(() => {
          this.loading = false
        })
      },
      addNew (project) {
        this.$emit('pick', project)
        // this.$emit('close')
      },
      isSelected ({ id }) {
        return this.list.findIndex(t => t.id === id) > -1
      }
    },
    mounted () {
      this.getProjects()
    },
    components: { HighlightText }
  }
</script>
